var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8781 0.421628C29.6057 -0.559993 30.98 0.225304 30.98 2.22781V7.41077C30.98 9.37401 30.98 12.633 30.98 14.5962V19.7792C30.98 21.7424 29.5664 22.567 27.8781 21.5854L23.4019 18.9939C21.6742 18.0123 18.8864 16.4024 17.1588 15.3815L12.6826 12.79C10.9549 11.8084 10.9549 10.1986 12.6826 9.17768L17.1588 6.5862C18.8864 5.60458 21.6742 3.99473 23.4019 2.97384L27.8781 0.421628Z",
    fill: "#603004"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.864133 0.61792H5.61518C6.08636 0.61792 6.479 1.01057 6.479 1.48175V20.5644C6.479 21.0356 6.08636 21.4283 5.61518 21.4283H0.864133C0.392955 21.4283 0.000308037 21.0356 0.000308037 20.5644V1.48175C0.000308037 1.01057 0.392955 0.61792 0.864133 0.61792Z",
    fill: "#603004"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.eac3cac055ffd59ecc63aa09e997bae1.svg";
export { ForwardRef as ReactComponent };